import { TreeSelectProps as ITreeSelectProps, TreeSelect } from 'antd'
import React from 'react'
import styled from 'styled-components'

const InternalTreeSelect = React.memo((props: ITreeSelectProps) => {
  return <StyledTreeSelect {...props} />
})

export type TreeSelectProps = ITreeSelectProps

export default InternalTreeSelect

const StyledTreeSelect = styled(TreeSelect)`
  &.ant-select {
    .ant-select-clear {
      background: transparent !important;
    }
    & svg[data-icon='close-circle'] {
      fill: ${p => p.theme.select.clearIconFill};
    }
    & svg[data-icon='down'] {
      fill: ${p => p.theme.select.arrowDownIconFill};
    }
    &.ant-select-disabled.ant-select:not(.ant-select-customize-input)
      .ant-select-selector {
      background: ${p => p.theme.select.disabledBg};
    }
    &.ant-select-status-error {
      .ant-select-selector {
        background-color: ${p => p.theme.select.bg} !important;
      }
    }
    .ant-select-selector {
      border-radius: 4px;
      background: ${p => p.theme.select.bg};
      color: ${p => p.theme.select.color};
      border-color: ${p => p.theme.select.borderColor};
      &:hover,
      &:active,
      &:focus {
        border-color: ${p => p.theme.select.hoverAndFocusBorderColor};
      }
      & .ant-select-selection-placeholder {
        color: ${p => p.theme.select.placeholderColor};
      }
    }
    .ant-select-selection-item-content {
      color: ${p => p.theme.select.tagColor};
    }

    .ant-select-arrow-icon {
      position: relative;
      top: -1px;
      font-size: 14px;
    }

    &.selection__multiple-items--hide
      .ant-select-selection--multiple
      .ant-select-selection__choice__disabled {
      display: none;
    }
  }
`
